export default "__VITE_ASSET__BSuNRJfO__"